import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { DpeState, PropertyDto } from '@workspace/data-types';
import { EnergyClassSelectorComponent } from '../../energy-class-selector/energy-class-selector.component';

@Component({
  selector: 'etxe-property-dpe-display',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, EnergyClassSelectorComponent],
  templateUrl: './dpe-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDpeDisplayComponent {
  property = input.required<PropertyDto>();
  DpeState = DpeState;

  get dpeStatusLabel(): string {
    const state = this.property()?.dpe?.state;
    switch (state) {
      case DpeState.TO_DO:
        return 'À réaliser';
      case DpeState.IN_PROGRESS:
        return 'En cours de réalisation';
      case DpeState.NOT_SUBJECT:
        return 'Non soumis au DPE';
      case DpeState.DONE:
        return 'Réalisé';
      default:
        return 'Inconnu';
    }
  }

  getQualityBadgeClass(quality?: string | null): string {
    if (!quality) return 'bg-neutral-a2 text-neutral-11 border-neutral-a5';
    const q = quality.toLowerCase().trim();
    if (q.includes('très bonne') || q === 'tres bonne') {
      return 'bg-jade-a3 text-jade-12 border-jade-a7';
    }
    if (q.includes('bonne')) {
      return 'bg-jade-a2 text-jade-11 border-jade-a5';
    }
    if (q.includes('moyenne')) {
      return 'bg-amber-a2 text-amber-11 border-amber-a6';
    }
    if (q.includes('insuffisante')) {
      return 'bg-ruby-a2 text-ruby-11 border-ruby-a6';
    }
    return 'bg-neutral-a2 text-neutral-11 border-neutral-a5';
  }

  getQualityIcon(quality?: string | null): string {
    if (!quality) return 'help_outline';
    const q = quality.toLowerCase().trim();
    if (q.includes('bonne')) return 'check_circle';
    if (q.includes('moyenne')) return 'warning';
    if (q.includes('insuffisante')) return 'error_outline';
    return 'info';
  }
}
